import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { TranslatedText } from "@/components/common/text";
import { useIsDarkTheme } from "@/components/layout/useIsDarkTheme";
import { setSearchType } from "@/state/searchInputSlice";
import { clearCurrentSearch } from "@/state/currentSearchSlice";
import { useIsDev } from "@/auth/roles";

export const CompanyAnalytics = () => {
    const isDarkTheme = useIsDarkTheme();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setSearchType("company_analytics"));
        dispatch(clearCurrentSearch());
    }, []);

    const isDev = useIsDev();

    return isDev ? (
        <div className="flex flex-col max-w-[1140px] lg:mx-auto pt-2">
            <div className="flex flex-col sm:flex-row justify-between mb-4 w-full items-center">
                <h2 className="text-[22px]/[35px] text-cm-p-text-primary font-medium">
                    <TranslatedText>Company analytics</TranslatedText>
                </h2>
                <div className="flex flex-col sm:flex-row gap-2 items-center">
                    <div className="flex items-center bg-cm-p-surface gap-3 px-4 py-2 rounded-[70px] border border-cm-p-outline max-w-[158px]">
                        <p className="text-sm/[22px] text-cm-p-text-primary font-medium">All trailer types </p>
                        <svg width="10" height="5" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1.5L6 6.5L11 1.5" stroke="#8F99A3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <div className="bg-cm-p-surface-container rounded-[64px] flex items-center justify-center">
                        <div className="max-w-[68px] bg-cm-p-surface px-4 py-[7px] text-cm-p-text-primary text-sm/24px font-medium rounded-[58px] border border-cm-p-outline">
                            WoW
                        </div>
                        <div className="max-w-[66px] px-4 py-[7px] text-sm/24px text-cm-p-text-primary font-normal">MoM</div>
                    </div>
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-[13px] gap-x-[16px]">
                {[1, 2, 3, 4].map((n) => (
                    <img
                        src={`/images/company-analytics-${isDarkTheme ? "d" : "w"}-${n}.png`}
                        alt={`Company Analytics Graph ${n}`}
                        key={n}
                        className="w-full h-auto"
                    />
                ))}
            </div>
            <div className="flex flex-col items-center gap-2 mt-[28px] max-w-[570px] mx-auto">
                <TranslatedText className="text-cm-p-text-primary text-[18px]/[28px] font-semibold text-center">
                    CargoMinds Company Analytics
                </TranslatedText>
                <TranslatedText className="text-cm-p-text-primary text-[16px]/[25px] font-normal text-center">
                    Dashboards and metrics deliver the insights managers and users need to promote ongoing improvement and enhance
                    efficiency.
                </TranslatedText>
            </div>
        </div>
    ) : null;
};
